import _ from "underscore";
import render from "../../../utilities/render";
import AsnDetailStore from "../../../stores/AsnDetailStore";
import AsnShippingPalletStore from "../../../stores/AsnShippingPalletStore";
import AsnStore from "../../../stores/AsnStore";
import {isTruthy} from '../../../utilities/general';
const packingDetailHtml = require("./html/reviewPackingDetailsTemplate.html");

const packingProductListHtml = require("./html/reviewPackingProductList.html");

export default function PackingReviewView(wizard){
  const self = this;
  const wizardElement = wizard.getWizardElement();
  const packingDetailsContainer = wizardElement.find('.review-packing-details-container');

	let upperCasePacking, lowerCasePacking;

	self.init = function() {
		let shouldSelectPallet = !!AsnStore.getAsnWithShippingMethod("pallet");
    let shouldSelectPallet2=AsnStore.getAsnWithShippingMethod().shippingMethod;

    if(shouldSelectPallet2 === "pallet"){
      upperCasePacking = "Pallet";
      lowerCasePacking = "pallet";
    }else{
      upperCasePacking = "Case";
      lowerCasePacking = "case";
    }
    bindStores();
    populatePackingDetails();
    //populateAsnShippingPallets();
	};

	function bindStores(){
    AsnStore.bindListener("asns:shipping_method_changed", populatePackingDetails);

    AsnStore.bindListener("asns:shipping_partner_changed", populatePackingDetails);
    AsnDetailStore.bindListener("asn_details:add", populatePackingDetails);
    AsnDetailStore.bindListener("asn_details:remove", populatePackingDetails);
    AsnDetailStore.bindListener("asn_details:change", populatePackingDetails);
  }

 	function populatePackingDetails() {
    packingDetailsContainer.html('');
    _(getCasesOrPallets()).map((asnDetail, rowIdx)=>{
      rowIdx = rowIdx + 1;
      let ids = _(asnDetail).pluck("id");
      const packingDetail = buildPackingDetail(ids);
      packingDetailsContainer.append(packingDetail);
    });
  }

 
  function getCasesOrPallets(){
    if(isPallet()){
      return AsnDetailStore.organizeIntoPallets(getAsnDetails());
    }else if(isParcel()){
      return AsnDetailStore.organizeIntoCases(getAsnDetails());
    }
  }


  function buildPackingDetail(ids){
    let numberOfCasesOrPallets = 1;
    let caseOrPalletLineNumber = 1;
    const asnDetail = getFirstProduct(ids);
    if(!asnDetail.packingTypeName){ // if name is not exist
      if(isParcel()){
        asnDetail.packingTypeName = "Case "+asnDetail.caseLineNumber;
      }else{
        asnDetail.packingTypeName = "Pallet "+asnDetail.palletLineNumber;
      }
    }

    if(isParcel()){
      numberOfCasesOrPallets = getFirstProductNumberOfCases(ids);
      caseOrPalletLineNumber = asnDetail.caseLineNumber;
    }else{
      numberOfCasesOrPallets = getFirstProductNumberOfPallets(ids);
      caseOrPalletLineNumber = asnDetail.palletLineNumber;
    }

    let customCaseOrPalletIds = "";
    if(asnDetail.hasCustomIds){
      customCaseOrPalletIds = asnDetail.customCaseOrPalletIds;
    }

    const packingDetailsEl = render(
      packingDetailHtml, {
        packingTypeUpperCase: getPackingType(upperCasePacking),
        packingType: getPackingType(lowerCasePacking),
        packingTypeName: asnDetail.packingTypeName,
        numberOfCasesOrPallets: numberOfCasesOrPallets,
        revPackingProductsList: getPackingDetailProducts(ids),
        caseOrPalletLineNumber: caseOrPalletLineNumber,
        hasMultipleProducts: true,
        isFedex: hasShippingPartner(),
        isPalletShipping: AsnStore.hasFreigthSelected(getAsn().id),
        length: asnDetail.asd_package_length,
        width: asnDetail.asd_package_width,
        height: asnDetail.asd_package_height,
        weight: asnDetail.asd_package_weight,
        declaredValue: isTruthy(asnDetail.dvlInsideCase)?asnDetail.declaredValue:0,
        hasCustomIds: asnDetail.hasCustomIds,
        customCaseOrPalletIds: customCaseOrPalletIds
      });
    return packingDetailsEl;
  }

 
  function hasShippingPartner(){
    return AsnStore.hasShippingPartner(getAsn());
  }

  function getFirstProductNumberOfCases(ids){
    return parseInt(getFirstProduct(ids).numberOfCases, 10) || 1;
  }

  function getFirstProductNumberOfPallets(ids){
    return parseInt(getFirstProduct(ids).numberOfPallets, 10) || 1;
  }

  function getFirstProduct(ids){
    return getProducts(ids)[0];
  }

  function getFirstAsnShippingPallet(ids){
    return getAsnShippingPalletsView(ids)[0];
  }

  function getPackingType(packingType){
    return packingType;
  }

  function getPackingDetailProducts(ids) {
    let html = "";
    _(getProducts(ids)).map((asnDetail, rowIdx)=>{
      rowIdx = rowIdx + 1;
      html = html.concat(buildPackingDetailList(asnDetail, rowIdx));
    });
    return html;
  }

  function getProducts(ids){
    return AsnDetailStore.getAsnDetails(ids);
  }

  function getAsnShippingPalletsView(ids){
    return AsnShippingPalletStore.getAsnShippingPallets(ids);
  }

  function buildPackingDetailList(asnDetail, rowIdx){
    let totalUnits = 1;
    if(isParcel()){
      totalUnits = asnDetail.unitsPerCase * asnDetail.numberOfCases;
    }else{
      totalUnits = asnDetail.unitsPerCase * asnDetail.numberOfPallets;
    }

    const listItem = render(
      packingProductListHtml, {
        packingType: getPackingType(lowerCasePacking),
        asnDetailRowId: asnDetail.id,
        skuName: asnDetail.sku,
        skuDesc: asnDetail.sku,
        unitsPerCase: asnDetail.unitsPerCase,
        totalUnits: totalUnits,
        packingExpDate: asnDetail.expirationDate,
        lotNumber: asnDetail.batchLotNumber,
        hasExpDateField: hasExpDate(asnDetail.sku),
        hasLotNumberField: hasLotNumber(asnDetail.sku)
      });
    return listItem;
  }

  function hasLotNumber(sku){
    return doesProductForSkuRequireLotNumber(sku);
  }

  function doesProductForSkuRequireLotNumber(sku){
    const productItem = getProductItemForSku(sku);
    return productItem && ProductItemStore.doesRequireLotNumber(productItem);
  }

  function hasExpDate(sku){
    return isProductForSkuPerishable(sku);
  }

  function isProductForSkuPerishable(sku){
    const productItem = getProductItemForSku(sku);
    return productItem && ProductItemStore.isPerishable(productItem);
  }

  function getProductItemForSku(sku){
    return ProductItemStore.findWhere({itmSku: sku});
  }

  function getShippingMethod(){
    return AsnStore.getShippingMethod();
  }

  function isParcel(){
    return getShippingMethod() === 'parcel';
  }

  function isPallet(){
    return getShippingMethod() === 'pallet';
  }

  function getAsnDetails(){
    return AsnStore.getAsnDetails(getAsn());
  }

  function getAsnShippingPallets(){
    return AsnStore.getAsnShipppingPallets(getAsn());
  }

  function getAsn(){
    if(isPallet())
      return AsnStore.getOrCreateAsnWithShippingMethod("pallet");
    else if(isParcel())
      return AsnStore.getOrCreateAsnWithShippingMethod("parcel");
  }

 function hasFreigthSelected(asnId){
    return AsnStore.hasFreigthSelected(asnId);
  }

}



// WEBPACK FOOTER //
// ./src/pages/asns/ReviewTab/PackingReviewView.js